import HeroSection from './components/HeroSection';
import ActivitiesPreview from './components/ActivitiesPreview';
import PartnersPreview from './components/PartnersPreview';

export default function Home() {
  return (
    <main>
      <HeroSection />
      <ActivitiesPreview />
      <PartnersPreview />
    </main>
  );
}